import {
  BrandAndMarketListItem, CodeAndLabel, FormDataRouteRestriction,
  GuidIdAndLabel, GuidIdCodeAndLabel, Int32IdAndLabel, RuleFormDataAgencyOrGroup
} from '../../../integrated-client/models'

export interface IAncillaryDistributionEditorData {
  id?: string | null;
  supplier?: GuidIdAndLabel;
  carrier?: GuidIdCodeAndLabel;
  ancillary?: GuidIdAndLabel;
  ancillaryCategory?: GuidIdAndLabel;
  brandAndMarket?: BrandAndMarketListItem;
  relevance?: number;
  salesJourneys?: Array<CodeAndLabel> | null;
  distributionChannels?: Array<Int32IdAndLabel> | null;
  agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
  routes?: Array<FormDataRouteRestriction> | null;
  effectiveFrom?: object | null;
  effectiveTo?: object | null;
  allowEdit?: boolean;
  disabled?: boolean;
}

export interface IEditorData {
  ancillaryDistributionEditorData: IAncillaryDistributionEditorData,
  validation?: any
}

export class AncillaryDistributionEditorData implements IAncillaryDistributionEditorData {
  id?: string | null;
  supplier?: GuidIdAndLabel;
  carrier?: GuidIdCodeAndLabel;
  ancillary?: GuidIdAndLabel;
  ancillaryCategory?: GuidIdAndLabel;
  brandAndMarket?: BrandAndMarketListItem;
  relevance?: number;
  salesJourneys?: Array<CodeAndLabel> | null;
  distributionChannels?: Array<Int32IdAndLabel> | null;
  agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
  routes?: Array<FormDataRouteRestriction> | null;
  effectiveFrom?: object | null;
  effectiveTo?: object | null;
  allowEdit?: boolean;
  disabled?: boolean;

  constructor() {
    this.relevance = 100;
  }
}

export class EditorData implements IEditorData {

  ancillaryDistributionEditorData: IAncillaryDistributionEditorData
  validation?: any

  constructor() {
    this.ancillaryDistributionEditorData = new AncillaryDistributionEditorData()
  }
}
